// Flag notation for Cleaning app, prepend flags with:
// Module Flags: "CleaningManagement_MF_"
// Feature Flags: "CleaningManagement_FF_"

export const Flags = {
  CleaningManagement_FF_Is_Clarity_Active: "CleaningManagement_FF_Is_Clarity_Active",
};
